export default __webpack_public_path__ + "static/media/steam-logo-white.e72a9efb.svg";